import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import TopNav from '../components/sections/TopNav';
import SiteFooter from '../components/sections/SiteFooter';
import VoicemailRecorder from '../components/VoicemailRecorder';

/**
 * /voicemail - dedicated public page for leaving an audio message. Uses
 * the same VoicemailRecorder component surfaced in the tip modal so the
 * flow is identical whether the reader arrives via link, PWA shortcut, or
 * from the tip button.
 */
const Voicemail = () => (
  <div className="min-h-screen bg-black text-white" data-testid="voicemail-page">
    <TopNav />
    <main className="max-w-md mx-auto px-4 py-12">
      <Link to="/" data-testid="voicemail-back" className="inline-flex items-center gap-1 text-zinc-400 hover:text-white text-[11px] font-black uppercase tracking-[0.25em] mb-6">
        <ArrowLeft className="h-3.5 w-3.5" /> Home
      </Link>
      <VoicemailRecorder onDone={() => window.scrollTo({ top: 0, behavior: 'smooth' })} />
    </main>
    <SiteFooter />
  </div>
);

export default Voicemail;
